import { useEffect, useRef, useState } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { useDispatch } from "react-redux";
import { CaretLeftFill, CaretRightFill, EyeFill, Link45deg, PencilFill, Trash, X } from "react-bootstrap-icons";
import { deleteReminder, getReminder, readReminder, searchUnreadReminders } from '../../store/api/ReminderAPI';
import { setDialog } from "../../store/api/GetAllProduct";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay, faTimes } from '@fortawesome/free-solid-svg-icons';
import ModalReminder from './ModalReminder';
let totalPage = 0;

const ModalUnreadReminders = ({ popData, setPopData }) => {

    const currPage = useRef(1);
    const { show } = popData;

    //const unreadReminders = useSelector(state => state.UserReducer.unreadReminders);
    const [unreadReminders, setUnreadReminders] = useState({ TotalCount: 0 });
    if (totalPage < 1) {
        const t = unreadReminders && unreadReminders.TotalCount ? Number(unreadReminders.TotalCount) : 0;
        totalPage = Math.floor(t / 10) + ((t % 10) > 0 ? 1 : 0);
    }

    const dispatch = useDispatch();
    const [showReminders, setRemindersShow] = useState(true);
    const [popReminder, setPopReminder] = useState({ show: false });
    const changePage = (inc) => {
        if (inc) {
            currPage.current++;
        }
        else {
            currPage.current--;
        }
        dispatch(searchUnreadReminders(currPage.current - 1, setUnreadReminders));
    }
    const onSuccess = () => {
        currPage.current = 1;
        totalPage = 0;
        dispatch(searchUnreadReminders(0, setUnreadReminders));
    }
    const read = (id) => {
        dispatch(readReminder(id, onSuccess));
    }
    const showReminder = (id) => {
        const onSuccess = (rem) => {
            setPopReminder({ show: true, reminder: rem, setUnreadReminders: () => dispatch(searchUnreadReminders(0, setUnreadReminders)) });
        }
        dispatch(getReminder(id, onSuccess));
    }
    const close = () => {
        setPopData({ show: false });
    }
    function showReminderAttachment(reminder) {
        switch (reminder.AttachmentType) {
            case "customer":
                window.open(`/CRM/AddEditCustomer/${reminder.AttachmentID}`);
                break;
            case "pre_customer":
                window.open(`/CRM/AddEditPreCustomer/${reminder.AttachmentID}`);
            case "acc_doc":
                window.open(`/Accounting/AddEditDocument/${reminder.AttachmentID}`)
        }
    }
    useEffect(() => {
        if (show) {
            currPage.current = 1;
            totalPage = 0;
            dispatch(searchUnreadReminders(0, setUnreadReminders));
        }
    }, [show])
    return (
        <Modal size="lg" show={show && unreadReminders?.Data?.length > 0} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span><FontAwesomeIcon icon={faCalendarDay} size='lg' />&nbsp;
                    یادآوری ها
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={close} />
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                <ModalReminder pop={popReminder} setPop={setPopReminder} />
                <Table>
                    <thead>
                        <tr>
                            <th>تاریخ یادآوری</th>
                            <th>نوع یادآوری</th>
                            <th>متن یادآوری</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(unreadReminders.Data) && unreadReminders.Data.map((item, i) =>
                            <tr key={i} className="resultTableRow">
                                <td style={{ width: "110px" }}>{item.PAlarmDate + "-" + item.AlarmHour}</td>
                                <td style={{ width: "120px" }}>{item.PAttachmentType}</td>
                                <td>{item.RemBody}</td>
                                <td style={{ width: "120px" }}>
                                    <EyeFill className='rowBtn' size={18} color="#2e8b57" onClick={() => read(item.ID)} />
                                    &nbsp;
                                    <Trash className='rowBtn' size={18} color="red" onClick={() => {
                                        dispatch(setDialog({
                                            status: 'show',
                                            arrayBtn: ['yes', 'no'],
                                            dialogTitle: 'حذف یادآوری',
                                            dialogText: 'آیا از حذف مطمئن هستید؟',
                                            okOperation: deleteReminder(item.ID, onSuccess)
                                        }))
                                    }} />
                                    &nbsp;
                                    <PencilFill className='rowBtn' size={18} color="orange" onClick={() => showReminder(item.ID)} />
                                    &nbsp;
                                    {Number(item.AttachmentID) > 0 && <Link45deg className='rowBtn' color="blue" size={20} onClick={() => showReminderAttachment(item)} />}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
                <div>
                    <button className="btn btn-block" style={{ padding: "2px", marginRight: "2px" }} title='صفحه قبل' disabled={currPage.current === 1} onClick={() => { changePage(false) }}><CaretRightFill size={25} /></button>
                    <span>{currPage.current + " از " + totalPage}</span>
                    <button className="btn btn-block" style={{ padding: "2px", marginLeft: "2px" }} title='صفحه بعد' disabled={currPage.current === totalPage} onClick={() => changePage(true)}><CaretLeftFill size={25} /></button>
                </div>
            </Modal.Body>
        </Modal >
    )
}
export default ModalUnreadReminders;